<template>
    <div class="d-flex justify-content-center align-items-center">                
        <img class="item-emoji" src="../../assets/images/humor/great.png" v-if="humor == 5">                                                     
        <img class="item-emoji" src="../../assets/images/humor/well.png" v-if="humor == 4">                                 
        <img class="item-emoji" src="../../assets/images/humor/normal.png" v-if="humor == 3">                                 
        <img class="item-emoji" src="../../assets/images/humor/bad.png" v-if="humor == 2">                                 
        <img class="item-emoji" src="../../assets/images/humor/terrible.png" v-if="humor == 1">                
        <img class="item-emoji" src="../../assets/images/humor/neutral.png" v-if="humor == 0">                                                                
    </div>
</template>

<script>
export default {
    name: "HumorEmojis",
    props: {
        humor:{type:Number}        
    }
}
</script>
